import { Box, styled, StyleSystemProps } from '@withjoy/joykit';
import { CloseThick } from '@withjoy/joykit/icons';
import { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';

export const StyledClearFiltersContainer = styled(Box)<{ disabled: boolean }>``;
export const StyledCloseIconContainer = styled(CloseThick)``;

const contentContainerStyles: StyleSystemProps = {
  height: '100%',
};

const clearFiltersContainerStyles: StyleSystemProps = {
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: 'primary',
  flex: 1,
  _disabled: {
    opacity: 0.4,
  },
};

const spacingStackStyles: StyleSystemProps = {
  borderTopColor: 'mono3',
  borderBottom: 'none',
  borderWidth: '1px',
  borderLeftWidth: 0,
  borderRightWidth: 0,
  borderTopStyle: 'solid',
  marginTop: 5,
  padding: 6,
  marginX: -6,
};

export const registryPrimaryButtonStyles: ButtonOverrides = {
  Root: {
    props: {
      color: 'white',
      backgroundColor: 'mono14',
      _hover: {
        color: 'white',
        backgroundColor: 'mono11',
      },
      _active: {
        color: 'white',
        backgroundColor: 'black',
      },
      _disabled: {
        color: 'mono8',
        backgroundColor: 'mono3',
      },
    },
  },
};

export const styles = {
  contentContainer: contentContainerStyles,
  clearFiltersContainer: clearFiltersContainerStyles,
  spacingStack: spacingStackStyles,
  registryPrimaryButton: registryPrimaryButtonStyles,
};
